import React from 'react'
import PropTypes from 'prop-types'
import { pick } from 'lodash'
import Resource from 'common/components/Resource'
import Panel from 'common/components/Panel'
import { withUrlResource } from 'common/utils'
import { transformApiError } from 'common/api/errors'
import client from 'common/admin/client'
import ContactTopicForm from './Form'
import { useTranslation } from "react-i18next";

const handleSubmit = (buildingId, contactTopicId) => async (values, form) => {
  const body = pick(values, 'name', 'contact_email')
  const { setSubmitting, setErrors, setStatus } = form

  try {
    await client.patch(`buildings/${buildingId}/contact_topics/${contactTopicId}`, { body })
    setStatus({ success: true })
  } catch (error) {
    const apiError = transformApiError(error)
    if (apiError.empty()) {
      setErrors({ http: error.message })
    } else {
      setErrors(apiError.object())
    }
  }
  setSubmitting(false)
}

const EditContactTopic = ({ urlResource, match }) => {
  const { t } = useTranslation();
  
  return (
    <Resource
      name={`buildings/${urlResource.id}/contact_topics/${match.params.contactTopicId}`}
      resourceId={match.params.serviceId}
      render={topic => (
        <Panel title={t('contact_topics_create.edit_title')}>
          <ContactTopicForm
            isEdit
            handleSubmit={handleSubmit(urlResource.id, match.params.contactTopicId)}
            initialValues={{
              name: topic.name || '',
              contact_email: topic.contact_email || ''
            }}
          />
        </Panel>
      )}
    />
  );
}

EditContactTopic.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      contactTopicId: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  urlResource: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired
}

export default withUrlResource(EditContactTopic)
